var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"rounded":"","color":"success","min-width":"180","min-height":"35","block":_vm.$mq == 'sm',"loading":_vm.finalizando},on:{"click":_vm.finalizarAtestado}},[_vm._v("Finalizar / Enviar")])
}
var staticRenderFns = []

export { render, staticRenderFns }